<template>
  <span class="chip"><slot /></span>
</template>
<style scoped>
.chip {
  background-color: var(--light-gray);
  height: calc(1.5 * var(--grid));

  border-radius: var(--grid);
  padding: 0px var(--half-grid);
  margin: 0px 0.25rem 0px 0px;
  gap: var(--quarter-grid);
  display: inline-flex;
  align-items: center;
}
</style>
